<template>
  <div id="page-wrap">
    <div class="container-fluid">
      <div class="container">
        <div class="content-wrap">
          <div class="header">
            <h1>关于睿客云盘PC版升级说明</h1>
          </div>
          <div class="content">
            <ul>
              <p>各位老师和同学：</p>
            </ul>
            <ul>
              <p
                style="text-indent: 2em;"
              >睿客网于近期了发布了全新的版本。本次升级提升了用户体验，增强了Web端的群盘功能，欢迎您体验与提出宝贵意见和建议。睿客网PC版，本次升级，暂时去除了备份功能。后期将在调研用户需求后，重新上线发布。</p>
            </ul>
            <ul>
              <p style="float:right;">2019年11月</p>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Content",
  created() {
    this.$store.commit("SET_THEME", "升级说明");
  }
};
</script>

<style scoped>
</style>